// @flow
import React from 'react';
import * as css from './HeaderTele2.module.css';

type Props = {
  inverted?: boolean,
};
const BusinessLogoSvg = ({ inverted = false }: Props) => {
  return (
    <>
      {inverted ? (
        <div className={css.svgContainer}>
          <svg
            version="1.1"
            id="Lager_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 378 285"
            xmlSpace="preserve"
            className={css.svg}
          >
            <title>Tele2</title>
            <g>
              <path
                fill={inverted ? '#FFF' : '#000'}
                d="M0,49.87l53.93-7.5v19.67l-17.64,1.82v76.84H17.64V65.89L0,67.71V49.87z M62.64,41.15l54.74-7.7v19.66
                l-34.87,4.26v21.9l29.8-2.23v18.85l-29.8,1.82v24.33l34.87-0.81v19.46H62.64V41.15z M150.02,119.61l40.14-0.81v21.9h-62.85V32.03
                l22.71-3.24V119.61z M199.49,21.89l72.58-10.34v24.33l-46.43,5.27V66.5l39.74-3.04v23.31L225.64,89v28.79l46.43-1.62v24.53h-72.58
                V21.89z M376.47,112.92v27.77h-93.66v-24.73c18.45-17.43,41.76-42.57,50.28-52.51c6.69-7.91,9.73-14.6,9.73-21.49
                c0-7.7-4.66-13.38-13.38-13.38c-10.95,0-17.84,8.31-17.84,22.3c0,1.42,0,3.04,0.2,4.46l-27.98,2.43C281.59,21.69,301.46,0,335.11,0
                c23.52,0,39.74,14.6,39.74,35.88c0,23.11-11.15,36.9-36.9,64.06l-13.79,14.39L376.47,112.92z"
              />
            </g>
            <g>
              <path
                fill={inverted ? '#FFF' : '#000'}
                d="M74.43,284.13v-38.99h22.55v3.96H78.88v12.92h16.88v4.01H78.88v18.09H74.43z"
              />
              <path
                fill={inverted ? '#FFF' : '#000'}
                d="M120.51,284.79c-10.17,0-17.65-8.08-17.65-20.18c0-12.1,7.48-20.13,17.65-20.13
                c10.23,0,17.71,8.14,17.71,20.13C138.21,276.65,130.73,284.79,120.51,284.79z M120.51,248.55c-7.81,0-13.09,6.65-13.09,16.06
                c0,9.4,5.11,16.11,13.09,16.11c7.97,0,13.14-6.71,13.14-16.11C133.65,255.2,128.32,248.55,120.51,248.55z M112.59,237.71
                c0-1.59,1.32-3.02,3.02-3.02c1.65,0,3.02,1.43,3.02,3.02c0,1.71-1.38,3.13-3.02,3.13C113.91,240.85,112.59,239.42,112.59,237.71z
                M122.38,237.71c0-1.59,1.37-3.02,3.08-3.02c1.65,0,3.02,1.43,3.02,3.02c0,1.71-1.38,3.13-3.02,3.13
                C123.75,240.85,122.38,239.42,122.38,237.71z"
              />
              <path
                fill={inverted ? '#FFF' : '#000'}
                d="M173.74,284.13h-5l-10.12-16.55h-7.26v16.55h-4.45v-38.99h13.31c7.64,0,12.59,4.18,12.59,11.11
                c0,5.99-3.63,10.01-9.35,11.05L173.74,284.13z M151.36,249.1v14.52h8.74c5.17,0,8.19-2.8,8.19-7.37c0-4.56-3.02-7.15-8.19-7.15
                H151.36z"
              />
              <path
                fill={inverted ? '#FFF' : '#000'}
                d="M205.57,245.14v3.96h-19.36v12.7h17.21v3.96h-17.21v14.35h19.36v4.01h-23.81v-38.99H205.57z"
              />
              <path
                fill={inverted ? '#FFF' : '#000'}
                d="M210.85,245.14h30.25v4.01h-12.92v34.98h-4.45v-34.98h-12.87V245.14z"
              />
              <path
                fill={inverted ? '#FFF' : '#000'}
                d="M269.79,284.13l-4.89-11.99h-15.84l-4.89,11.99h-4.67l16.33-39.32h2.25l16.39,39.32H269.79z M250.71,268.12
                h12.54l-6.27-15.4L250.71,268.12z"
              />
              <path
                fill={inverted ? '#FFF' : '#000'}
                d="M277.21,264.6c0-12.32,7.92-20.13,17.71-20.13c8.08,0,13.25,4.89,14.74,11.38l-4.29,0.61
                c-1.48-4.73-4.95-7.86-10.45-7.86c-7.2,0-13.14,5.83-13.14,16c0,10.23,5.72,16.06,13.03,16.06c6.87,0,11.11-4.12,11.49-12.15
                h-10.12v-3.96h14.52v2.31c0,11.11-6.1,17.87-15.95,17.87S277.21,276.87,277.21,264.6z"
              />
            </g>
            <circle fill="#FCBE00" cx="25.33" cy="195.5" r="12.59" />
            <circle fill="#DE054B" cx="365.38" cy="195.5" r="12.59" />
            <circle fill="#994996" cx="297.37" cy="195.5" r="12.59" />
            <circle fill="#004F9F" cx="229.36" cy="195.5" r="12.59" />
            <circle fill="#33B7EB" cx="161.35" cy="195.5" r="12.59" />
            <circle fill="#44AC3D" cx="93.34" cy="195.5" r="12.59" />
          </svg>
        </div>
      ) : (
        <div className={css.svgContainer}>
          <svg
            version="1.1"
            id="Lager_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 378 285"
            xmlSpace="preserve"
            className={css.svg}
          >
            <title>Tele2</title>
            <g>
              <path
                fill={inverted ? '#FFF' : '#000'}
                d="M0,49.87l53.93-7.5v19.67l-17.64,1.82v76.84H17.64V65.89L0,67.71V49.87z M62.64,41.15l54.74-7.7v19.66
                l-34.87,4.26v21.9l29.8-2.23v18.85l-29.8,1.82v24.33l34.87-0.81v19.46H62.64V41.15z M150.02,119.61l40.14-0.81v21.9h-62.85V32.03
                l22.71-3.24V119.61z M199.49,21.89l72.58-10.34v24.33l-46.43,5.27V66.5l39.74-3.04v23.31L225.64,89v28.79l46.43-1.62v24.53h-72.58
                V21.89z M376.47,112.92v27.77h-93.66v-24.73c18.45-17.43,41.76-42.57,50.28-52.51c6.69-7.91,9.73-14.6,9.73-21.49
                c0-7.7-4.66-13.38-13.38-13.38c-10.95,0-17.84,8.31-17.84,22.3c0,1.42,0,3.04,0.2,4.46l-27.98,2.43C281.59,21.69,301.46,0,335.11,0
                c23.52,0,39.74,14.6,39.74,35.88c0,23.11-11.15,36.9-36.9,64.06l-13.79,14.39L376.47,112.92z"
              />
            </g>
            <g>
              <path
                fill={inverted ? '#FFF' : '#000'}
                d="M74.43,284.13v-38.99h22.55v3.96H78.88v12.92h16.88v4.01H78.88v18.09H74.43z"
              />
              <path
                fill={inverted ? '#FFF' : '#000'}
                d="M120.51,284.79c-10.17,0-17.65-8.08-17.65-20.18c0-12.1,7.48-20.13,17.65-20.13
                c10.23,0,17.71,8.14,17.71,20.13C138.21,276.65,130.73,284.79,120.51,284.79z M120.51,248.55c-7.81,0-13.09,6.65-13.09,16.06
                c0,9.4,5.11,16.11,13.09,16.11c7.97,0,13.14-6.71,13.14-16.11C133.65,255.2,128.32,248.55,120.51,248.55z M112.59,237.71
                c0-1.59,1.32-3.02,3.02-3.02c1.65,0,3.02,1.43,3.02,3.02c0,1.71-1.38,3.13-3.02,3.13C113.91,240.85,112.59,239.42,112.59,237.71z
                M122.38,237.71c0-1.59,1.37-3.02,3.08-3.02c1.65,0,3.02,1.43,3.02,3.02c0,1.71-1.38,3.13-3.02,3.13
                C123.75,240.85,122.38,239.42,122.38,237.71z"
              />
              <path
                fill={inverted ? '#FFF' : '#000'}
                d="M173.74,284.13h-5l-10.12-16.55h-7.26v16.55h-4.45v-38.99h13.31c7.64,0,12.59,4.18,12.59,11.11
                c0,5.99-3.63,10.01-9.35,11.05L173.74,284.13z M151.36,249.1v14.52h8.74c5.17,0,8.19-2.8,8.19-7.37c0-4.56-3.02-7.15-8.19-7.15
                H151.36z"
              />
              <path
                fill={inverted ? '#FFF' : '#000'}
                d="M205.57,245.14v3.96h-19.36v12.7h17.21v3.96h-17.21v14.35h19.36v4.01h-23.81v-38.99H205.57z"
              />
              <path
                fill={inverted ? '#FFF' : '#000'}
                d="M210.85,245.14h30.25v4.01h-12.92v34.98h-4.45v-34.98h-12.87V245.14z"
              />
              <path
                fill={inverted ? '#FFF' : '#000'}
                d="M269.79,284.13l-4.89-11.99h-15.84l-4.89,11.99h-4.67l16.33-39.32h2.25l16.39,39.32H269.79z M250.71,268.12
                h12.54l-6.27-15.4L250.71,268.12z"
              />
              <path
                fill={inverted ? '#FFF' : '#000'}
                d="M277.21,264.6c0-12.32,7.92-20.13,17.71-20.13c8.08,0,13.25,4.89,14.74,11.38l-4.29,0.61
                c-1.48-4.73-4.95-7.86-10.45-7.86c-7.2,0-13.14,5.83-13.14,16c0,10.23,5.72,16.06,13.03,16.06c6.87,0,11.11-4.12,11.49-12.15
                h-10.12v-3.96h14.52v2.31c0,11.11-6.1,17.87-15.95,17.87S277.21,276.87,277.21,264.6z"
              />
            </g>
            <circle fill="#FCBE00" cx="25.33" cy="195.5" r="12.59" />
            <circle fill="#DE054B" cx="365.38" cy="195.5" r="12.59" />
            <circle fill="#994996" cx="297.37" cy="195.5" r="12.59" />
            <circle fill="#004F9F" cx="229.36" cy="195.5" r="12.59" />
            <circle fill="#33B7EB" cx="161.35" cy="195.5" r="12.59" />
            <circle fill="#44AC3D" cx="93.34" cy="195.5" r="12.59" />
          </svg>
        </div>
      )}
    </>
  );
};

export default BusinessLogoSvg;
